<template>
  <modal name="GERAL_APP_URL_VERSOCHAT" height="auto" width="600" :scrollable="true" :clickToClose="false">
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <h2 class="title">
          Alterar {{ parametro ? parametro.desc : "" }}
          <br />
          <small class="font-sm">Chave: {{ parametro.chave }}</small>
        </h2>

        <p class="hint">
          Informe a URL do VersoChat para acesso interno (rede local / IP privado) e para
          acesso externo (domínio público). Quando ambas ficarem vazias o chat é desabilitado.
        </p>

        <div class="form-group">
          <label for="url-interno">URL interna</label>
          <input
            id="url-interno"
            class="form-control"
            type="text"
            v-model="interno"
            placeholder="http://10.0.0.10:8084"
          />
          <small class="text-muted">Usada quando o acesso vem de um host de IP privado.</small>
        </div>

        <div class="form-group">
          <label for="url-externo">URL externa</label>
          <input
            id="url-externo"
            class="form-control"
            type="text"
            v-model="externo"
            placeholder="https://chat.cliente.com.br"
          />
          <small class="text-muted">Usada quando o acesso vem de um domínio ou IP público.</small>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="button button-success" v-on:click="updateParametro">
        Atualizar
      </button>
      <button class="button" v-on:click="close">Fechar</button>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../../../components/CloseModal";

export default {
  name: "GERAL_APP_URL_VERSOCHAT",
  props: ["update", "close", "parametro"],
  components: { CloseModal },
  data() {
    return {
      interno: "",
      externo: "",
    };
  },
  methods: {
    parseValor(valor) {
      if (!valor) {
        return { interno: "", externo: "" };
      }

      try {
        const decoded = JSON.parse(valor);
        if (decoded && typeof decoded === "object" && !Array.isArray(decoded)) {
          return {
            interno: decoded.interno || "",
            externo: decoded.externo || "",
          };
        }
      } catch (e) {
        // valor legado em texto simples
      }

      return { interno: valor, externo: valor };
    },
    updateParametro() {
      const interno = (this.interno || "").trim();
      const externo = (this.externo || "").trim();

      this.parametro.valor = interno || externo
        ? JSON.stringify({ interno, externo })
        : "";

      this.update(this.parametro);
    },
  },
  mounted() {
    const { interno, externo } = this.parseValor(this.parametro ? this.parametro.valor : "");
    this.interno = interno;
    this.externo = externo;
  },
};
</script>

<style scoped>
.modalbox {
  padding: 0;
}
.modalbox-content {
  max-height: calc(100vh - 220px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 32px;
}
.title {
  margin-bottom: 16px;
}
.title small {
  word-break: break-word;
}
.hint {
  font-size: 0.85rem;
  color: #667085;
  margin-bottom: 20px;
}
.form-group {
  margin-bottom: 16px;
}
</style>
